
<template>
<!-- Hindi Alphabet --> 
  <div class="lesson-container">
      <h3>Lesson Two: Alphabet</h3>
      <p>This second lesson in Hindi will focus on the Alphabet: vowels and consonants. As well as an introduction to the written script: Devanagari</p>

  </div>
</template>

<script>
export default {
  name: "HindiLessonOne",
  props: {
      currentLanguage: {type: String},
  },
  data() {
    return {
     
    };
  },
  methods: {
    
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
